import type { Action } from 'history';
import { useEffect, useMemo } from 'react';
import { useHistory, useLocation } from 'react-router';

type ScrollToTopProps = {
  disableScrollOnQueryUpdate?: boolean;
};

const isScrollToTopAction = (action: Action) =>
  !['POP', 'REPLACE'].includes(action);

/**
 * This ScrollToTop implementation is created to be used with
 * react-router routes only. When the old TransitionRouter is retired
 * we can replace index.tsx in this folder with this component.
 */
export const ScrollToTop = ({
  disableScrollOnQueryUpdate,
}: ScrollToTopProps) => {
  const { pathname, search } = useLocation();
  const { action } = useHistory();
  const path = useMemo(
    () => pathname + (disableScrollOnQueryUpdate ? '' : search),
    [pathname, search, disableScrollOnQueryUpdate]
  );
  useEffect(() => {
    if (isScrollToTopAction(action)) {
      window.scroll(0, 0);
    }
  }, [action, path]);
  return null;
};
